import styled from "@emotion/styled";
import { FlexRow, H2, Link, Stack } from "atoms";
import { Feed } from "./Feed";
import { useFeed } from "../api/usePosts";

type ProfileFeedProps = {
  artistId: string;
};

function ProfileFeed({ artistId }: ProfileFeedProps) {
  const { data } = useFeed(new URLSearchParams({ artistId, perPage: "4" }));

  const posts = data?.pages?.[0].data ?? [];
  if (!posts.length) return null;

  return (
    <SStack as="section" gap="sm">
      <FlexRow
        alignItems="flex-end"
        justifyContent={posts.length < 3 ? "flex-start" : "space-between"}
      >
        <H2 size="lg" style={{ margin: 0 }}>
          Updates
        </H2>
        <Link
          to={`/artists/${artistId}/updates`}
          variant={posts.length > 2 ? "primary" : "blank"}
          size="xxs"
        >
          View All Updates
        </Link>
      </FlexRow>

      <SFeed posts={posts} />
    </SStack>
  );
}

const SStack = styled(Stack)({
  gridArea: "posts",
  marginBottom: "3rem",
});

const SFeed = styled(Feed)(({ theme }) => ({
  gap: "1rem",
  [theme.breakpoints.tablet]: {
    gridTemplateColumns: `repeat(2, calc(50% - (${theme.spacing.gap} / 2)))`,
  },
  [theme.breakpoints.desktopLarge]: {
    gridTemplateColumns: `repeat(3, calc((100% / 3) - (${theme.spacing.gap} / 3)))`,
    "&>div:nth-of-type(4)": {
      display: "none",
    },
  },
  [theme.breakpoints.desktopXLarge]: {
    gridTemplateColumns: `repeat(4, calc(25% - (${theme.spacing.gap} * .375)))`,
    "&>div:nth-of-type(4)": {
      display: "flex",
    },
  },
}));

export { ProfileFeed };
